import React from "react";
import { motion } from "framer-motion";

interface BeatPulseProps {
  currentBeat: number;
  beatsPerBar: number;
  bpm: number;
  intensity?: number; // 0..1 visual strength (mode dependent)
}

export const BeatPulse: React.FC<BeatPulseProps> = ({
  currentBeat,
  beatsPerBar,
  bpm,
  intensity = 1,
}) => {
  const beatDur = 60 / bpm;
  return (
    <div
      data-testid="beat-pulse-indicator"
      className="flex items-center justify-center gap-3"
    >
      {Array.from({ length: beatsPerBar }).map((_, i) => {
        const active = i + 1 === currentBeat;
        return (
          <div key={i} className="flex flex-col items-center gap-1">
            <motion.div
              className="rounded-full"
              animate={{
                scale: active ? 1.35 : 1,
                backgroundColor: active
                  ? "rgba(245,158,11,1)"
                  : "rgba(148,163,184,0.28)",
                boxShadow: active
                  ? `0 0 ${12 * intensity}px rgba(245,158,11,${0.7 * intensity})`
                  : "0 0 0 rgba(0,0,0,0)",
              }}
              transition={{ duration: beatDur * 0.4, ease: "easeOut" }}
              style={{ width: 10, height: 10 }}
            />
            <span
              className={`text-[10px] font-mono ${
                active ? "text-amber-300" : "text-slate-600"
              }`}
            >
              {i + 1}
            </span>
          </div>
        );
      })}
    </div>
  );
};
